import { SxProps, Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { CrmColors } from '../../crm-theme';

/// Contorno com ponto colorido: o status já é pílula cheia; o texto usa a cor do tema.
export const tagChipSx = (cc: CrmColors, color: string, compact: boolean): SxProps<Theme> => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 0.5,
    maxWidth: '100%',
    height: compact ? 18 : 22,
    px: compact ? 0.75 : 1,
    borderRadius: '999px',
    border: `1px solid ${alpha(color, 0.6)}`,
    color: cc.textPrimary,
    fontSize: compact ? '10px' : '11px',
    fontWeight: 700,
    lineHeight: 1,
    whiteSpace: 'nowrap',
});

export const tagDotSx = (color: string): SxProps<Theme> => ({
    width: 6,
    height: 6,
    borderRadius: '50%',
    bgcolor: color,
    flexShrink: 0,
});
